import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()(() => ({
  closeIcon: {
    ...dFlex(),
    height: 44,
    padding: 6,
    width: 44,
  },
  buttons: {
    ...dFlex(),
    gap: 8,
  },
  chainButton: {
    padding: 6,
    width: 44,
  },
  connectWallet: {
    padding: 6,
    width: 44,
  },
  walletButton: {
    padding: 6,
    width: 44,
  },
}));

export default useStyles;
